export default __webpack_public_path__ + "static/media/529_dark.037fdd82.png";